import { render, staticRenderFns } from "./ModuleListItem.vue?vue&type=template&id=352f8850&scoped=true&functional=true&"
import script from "./ModuleListItem.vue?vue&type=script&lang=js&"
export * from "./ModuleListItem.vue?vue&type=script&lang=js&"
import style0 from "./ModuleListItem.vue?vue&type=style&index=0&id=352f8850&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "352f8850",
  null
  
)

export default component.exports